import React from "react";
import { Dialog } from "primereact/dialog";

interface Props {
  visible: boolean;
  onHide: () => void;
}

export default function AjudaSigilo({ visible, onHide }: Props) {
  return (
    <Dialog
      header="Como fazer uma contribuição sigilosa!"
      draggable={false}
      style={{ width: "50vw" }}
      visible={visible}
      onHide={onHide}
    >
      <div style={{ lineHeight: "2em" }} className="text-justify">
        <p>
          Para fazer uma contribuição sigilosa, siga os seguintes passos
          (demonstrados no gif abaixo):
        </p>
        1 - Selecione o trecho do texto que deseja marcar como sigiloso
        <br />2 - No menu em cima do editor de texto, clique na opção "Cor de
        fundo", selecione a cor para preencher a informação sigilosa
      </div>
      <img
        style={{ width: "100%" }}
        src="/images/ajuda-contribuicao-sigilosa.gif"
      />
    </Dialog>
  );
}
